export default __webpack_public_path__ + "static/media/01AW3SEP66.69eeb424.jpg";